import React from 'react';

const Block = function (props: {children: React.ReactNode}) {
  return (
    <div
      className={'border border-[#d4d9dc] rounded-[3px] p-5 pb-0 mb-[25px]'}
      {...props}
    />
  );
};

export default Block;
